<template>
    <Navbar :rightBtn="true" :title="'我的事项'"></Navbar>
    <van-tabs v-model:active='active' sticky @click-tab="changeTabs">
        <van-tab v-for="(item, index) in tabs" :title='item.title'>
        </van-tab>
    </van-tabs>
    <van-empty description="暂无数据" v-show="emptyShow" />
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="!emptyShow">
        <div class="policy-file-item" v-for="record in list" :key="record">
            <div class="policy-file-item-footer"
                @click="goEvaluateDetail(record, record.complete_flag == '1' ? 'look' : 'edit')">
                <div v-if="record.type == '1'">服务评价</div>
                <div>
                    <span>创建:{{ record.create_time }}</span>
                    <van-button class="btn" plain hairline type="primary" @click="goEvaluateDetail(record, 'edit')"
                        v-if="record.complete_flag == '0'">评价</van-button>
                    <van-button class="btn" plain hairline type="primary" v-else-if="record.complete_flag == '1'"
                        @click="goEvaluateDetail(record, 'look')">已评价</van-button>
                </div>
            </div>
        </div>
    </van-list>

</template>
<script>
import { useRouter } from "vue-router"
import Navbar from '@/components/Navbar.vue'
import ListItem from '@/components/ListItem.vue'
import moment from 'moment'
import { clickUrl } from '@/utils'
import { queryEvaluationByUserId } from '@/api/home'
import store from '@/store'

export default {
    name: 'MattersIndex',
    data() {

        return {
            active: '0',
            tabs: [
                { title: "全部事项", sn: 0 },
                { title: "服务评价", sn: 1 },
            ],
            list: [],
            loading: false,
            finished: false,
            emptyShow: false,
            page: {
                count: 0,
                size: 20,
                total: 0
            },
        }
    },
    components: { moment, Navbar, ListItem },
    computed: {},
    watch: {},
    mounted() {
        // this.onLoad()
    },

    methods: {
        changeTabs(val) {
            this.active = val.name
            this.page.count = 0
            this.list = []
            this.onLoad()
        },
        goEvaluateDetail(item, type) {
            clickUrl('/matters/evaluate/detail', { type: type, id: item.id })
        },
        async onLoad() {
            this.page.count += 1
            this.loading = true
            let params = {
                page: this.page.count,
                pageSize: this.page.size,
            }
            if(this.active){
               params.type = this.active
            }

            try {
                let res = await queryEvaluationByUserId(params)
                let list = res.result.data || []
                this.list = this.list.concat(list)
                this.page.total = res.result.total
                this.finished = this.list.length >= res.result.total && res.result.total != 0  ? true : false
                this.emptyShow = !res.result.total ? true : false
            }
            catch { }
            finally {
                this.loading = false
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.btn {
    margin-left: 15px;
}
</style>